import { applyDateOverride, REPORT_DEFAULT_PRESET } from './datePresets';
import {
  mergeInterveneAudienceFilters,
  readInterveneAudienceFilters,
} from './interveneFilters';

export function readReportCardFilters(querySpec = {}) {
  const dimensionValues = (querySpec.filters || []).find(
    (filter) => filter.field === querySpec.dimension && filter.operator === 'in'
  )?.value;
  if (querySpec.dataset === 'records') {
    return {
      dimensionValues: Array.isArray(dimensionValues)
        ? dimensionValues.map(String)
        : dimensionValues == null || dimensionValues === ''
          ? []
          : [String(dimensionValues)],
    };
  }
  if (querySpec.dataset === 'whatsapp_templates') {
    const raw = querySpec.template_id;
    const templateIds = Array.isArray(raw)
      ? raw.map(String).filter(Boolean)
      : raw ? [String(raw)] : [];
    const res = { templateId: templateIds[0] || '' };
    if (querySpec.bot_number) {
      res.botNumber = String(querySpec.bot_number);
    }
    Object.defineProperty(res, 'templateIds', { value: templateIds, writable: true, configurable: true, enumerable: false });
    return res;
  }
  if (querySpec.dataset === 'intervene') {
    return readInterveneAudienceFilters(querySpec.filters || []);
  }
  return {};
}

export function applyReportCardFilters(querySpec = {}, selected = {}) {
  let next = { ...querySpec };

  if (selected.dateRange && selected.dateRange.preset && selected.dateRange.preset !== REPORT_DEFAULT_PRESET) {
    next = applyDateOverride(next, selected.dateRange);
  }

  if (next.dataset === 'records' && next.dimension) {
    const existingFilters = (next.filters || []).filter(
      (filter) => !(filter.field === next.dimension && filter.operator === 'in')
    );
    const dimensionValues = Array.isArray(selected.dimensionValues)
      ? selected.dimensionValues.map(String).filter(Boolean)
      : [];
    next.filters = dimensionValues.length
      ? [
        ...existingFilters,
        { field: next.dimension, operator: 'in', value: dimensionValues },
      ]
      : existingFilters;
  }

  if (next.dataset === 'whatsapp_templates') {
    const ids = selected.templateIds?.length
      ? selected.templateIds.map(String).filter(Boolean)
      : selected.templateId
        ? (Array.isArray(selected.templateId) ? selected.templateId.map(String).filter(Boolean) : [String(selected.templateId)].filter(Boolean))
        : [];
    if (ids.length > 1) {
      next.template_id = ids;
    } else if (ids.length === 1) {
      next.template_id = ids[0];
    } else {
      delete next.template_id;
    }

    if (selected.botNumber) {
      next.bot_number = selected.botNumber;
    } else {
      delete next.bot_number;
    }
  }

  if (next.dataset === 'intervene') {
    next.filters = mergeInterveneAudienceFilters(next.filters || [], selected);
  }

  return next;
}
